module.exports = __webpack_public_path__ + "static/media/samsung.2cdc335d.jpg";